import type { LucideIcon } from 'lucide-react';
import { ChevronRight } from 'lucide-react';

interface QuickAccessTileProps {
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  title: string;
  description: string;
  /** Shows a "Coming Soon" badge instead of the chevron; suppresses hover affordance. */
  comingSoon?: boolean;
  /** @deprecated use comingSoon instead */
  disabled?: boolean;
}

export function QuickAccessTile({ icon: Icon, iconBg, iconColor, title, description, comingSoon, disabled }: QuickAccessTileProps) {
  const isComingSoon = comingSoon ?? disabled;
  return (
    <div
      aria-disabled={isComingSoon || undefined}
      className={`flex h-[120px] items-center gap-4 rounded-[20px] border border-[#ececec] bg-white p-[21px] shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)] transition-colors ${
        isComingSoon ? '' : 'hover:border-[#ff5a1f]/50'
      }`}
    >
      <span className="flex size-11 shrink-0 items-center justify-center rounded-xl" style={{ backgroundColor: iconBg }}>
        <Icon className="size-5" style={{ color: iconColor }} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-[#111827]">{title}</p>
        <p className="pt-0.5 text-xs leading-[16.5px] text-[#9ca3af]">{description}</p>
      </div>
      {isComingSoon ? (
        <span className="shrink-0 rounded-full bg-[#fce7f3] px-2.5 py-0.5 text-[10px] font-semibold text-[#be185d]">
          Coming Soon
        </span>
      ) : (
        <ChevronRight data-testid="tile-chevron" className="size-[15px] shrink-0 text-[#9ca3af]" />
      )}
    </div>
  );
}
